import { FetchEventsResponse } from "../../../types/apiResponsesTypes";
import GenericTable from "../GenericTable";
import "./TableEvents.scss";
import { useNavigate } from "react-router-dom";
import useTableEvents from "./hooks/useTableEvents";
import { Card } from "antd";
import { EventPartial } from "../../../types/events";

type Props = {
  eventsData: FetchEventsResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onDelete: (id: number) => void;
  // Set to false when the caller (ex: Dashboard) wraps this table in its own card
  renderCard?: boolean;
};

const TableEvents: React.FC<Props> = ({
  eventsData,
  fetchData,
  onDelete,
  isLoading,
  renderCard = true,
}) => {
  const navigate = useNavigate();

  const { columns, onRowClick } = useTableEvents({ navigate, onDelete });

  const table = (
    <GenericTable<EventPartial>
      results={eventsData?.results || []}
      count={eventsData?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
      direction={["descend"]}
    />
  );

  if (!renderCard) {
    return table;
  }

  return (
    <Card title="ÃvÃ©nements Ã  traiter" bordered={false}>
      {table}
    </Card>
  );
};

export default TableEvents;
